<template>
    <b-card-text>
        <p class="mb-0" style="font-size: 21px"><b>Datos de la Sucursal Principal</b></p>
        <b-row>
            <b-col cols="12" md="6">
                <ValidationProvider name="Nombre"  rules="required|min:3" v-slot="{ errors, valid }">
                    <b-form-group 
                        label="Nombre:"
                        label-for="formDataBranchName">
                        <b-form-input
                            id="formDataBranchName"
                            v-model="formData.branchName"
                            type="text"
                            autocomplete="off"
                            required
                            :state="errors[0] ? false : (valid ? true : null)"
                            placeholder="Ingrese el nombre"
                            ></b-form-input>
                        <b-form-invalid-feedback>
                            {{ errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" md="6">
                <ValidationProvider name="Telefono"  rules="required" v-slot="{ errors, valid }">
                    <b-form-group
                        label="Telefono:"
                        label-for="formDataBranchPhoneNumber">
                        <b-form-input
                        id="formDataBranchPhoneNumber"
                        v-model="formData.branchPhoneNumber"
                        type="text"
                        autocomplete="off"
                        required
                        placeholder="Ingrese el telefono"
                        :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                            {{ errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" md="6">
                <ValidationProvider name="Departamento"  rules="required" v-slot="{ errors, valid }">
                    <b-form-group 
                        label="Departamento:"
                        label-for="formDataBranchProvinceId">
                        <b-form-select
                            v-model="formData.branchProvince_id"
                            :options="provinces_list"
                            id="formDataBranchProvinceId"
                            class="mb-3"
                            value-field="id"
                            text-field="nombre"
                            :state="errors[0] ? false : (valid ? true : null)"
                            @change="getCitiesList()"
                            >
                            <template #first>
                                <b-form-select-option value="">SELECCIONE</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-form-invalid-feedback>
                            {{ errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" md="6">
                <ValidationProvider name="Ciudad"  rules="required" v-slot="{ errors, valid }">
                    <b-form-group 
                        label="Ciudad:"
                        label-for="formDataBranchCityId">
                        <b-form-select
                            v-model="formData.branchCity_id"
                            :options="cities_list"
                            id="formDataBranchCityId"
                            class="mb-3"
                            value-field="id"
                            text-field="nombre"
                            :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template #first>
                                <b-form-select-option value="">SELECCIONE</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-form-invalid-feedback>
                            {{ errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" md="12">
                <ValidationProvider name="Dirección"  rules="required|min:3" v-slot="{ errors, valid }">
                    <b-form-group 
                        label="Dirección:"
                        label-for="formDataBranchAddress">
                        <b-form-textarea
                            id="formDataBranchAddress"
                            v-model="formData.branchAddress"
                            type="text"
                            autocomplete="off"
                            required
                            :state="errors[0] ? false : (valid ? true : null)"
                            placeholder="Ingrese la dirección"
                            ></b-form-textarea>
                        <b-form-invalid-feedback>
                            {{ errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
        </b-row>
    </b-card-text>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
    name: "BranchDataForm",
    props: {
        formData: {
            type: Object
        }
    },
    data(){
        return{
            provinces_list: [],
            cities_list: [],
        }
    },
    created(){
        this.getProvincesList();
    },
    methods: {
        ...mapMutations(['setLoading']),
        async getProvincesList() {
            this.setLoading(true)
            await this.$conectar.post('direcciones/get-departamentos-list')
            .then(response =>{
                this.provinces_list = response.data.departamentosList;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async getCitiesList() {
            this.formData.branchCity_id = '';
            this.provinceSelected = { 
                departamento_id:   this.formData.branchProvince_id, 
            }
            this.setLoading(true)
            await this.$conectar.post('direcciones/get-ciudades-list', this.provinceSelected)
            .then(response =>{
                this.cities_list = response.data.ciudadesList;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
    }
    
}
</script>